<template>
  <div>
    <!-- 公共头部 -->
    <Header></Header>
    <div class="wrap_box">
      <div class="top">
        <div class="individuals_box w1200">
          <div class="individuals_left">
            <div class="header_shot">
              <img :src="HeadUrl" v-if="HeadUrl" />
            </div>
            <p class="people-name">
              {{ NickName }}，{{text}}好
              <span>{{MobileNumber}}</span>
            </p>
          </div>
          <div class="individuals_right" @click="cutNavMenu('editor', 0, '1')">
            <img src="../assets/personal/xiugai.png" />
            编辑个人信息
          </div>
        </div>
      </div>
      <div class="w1200">
        <calendar ref="calendar" />
        <!-- set -->
        <ul class="el-box">
          <li :class="{ active: index == 1 }" @click="cutNavMenu('myMission', 1)">我的课程</li>
          <li :class="{ active: index == 2 }" @click="cutNavMenu('myLanguage', 2)">我的语言测试</li>
          <li :class="{ active: index == 3 }" @click="cutNavMenu('collectTopic', 3)">收藏的题</li>
          <li :class="{ active: index == 4 }" @click="cutNavMenu('coupon', 4)">激活兑换</li>
          <li :class="{ active: index == 5 }" @click="cutNavMenu('notice', 5)">消息通知</li>
        </ul>
        <!-- 右边组件切换 -->
        <div class="w1200">
          <router-view></router-view>
        </div>
        <div class="device_test">
          <span class="btn_value" @click="toDeviceTest">设备检测</span>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import Header from "../components/header/Header.vue";
  import calendar from "./calendar/calendar.vue";
  export default {
    name: "personalCentre",
    components: {
      Header,
      calendar
    },
    data() {
      return {
        NickName: "",
        HeadUrl: "",
        yyjf: "",
        MobileNumber: "",
        text: "",
        activeName: "0",
        index: "",
        cur: "",
      };
    },
    created: function() {
      var that = this;
      this.leftNav();
      this.tokenkey = that.$cookies.get("token");
      this.UserInfo();
      if (!this.$cookies.isKey("token")) {
        this.$router.push("/index");
      }
    },
    methods: {
      // 个人信息
      UserInfo() {
        let that = this;
        this.$http
          .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
            headers: {
              token: that.tokenkey
            }
          })
          .then(function(result) {
            // // console.log(result)
            that.userId = result.data.results.Id;
            that.NickName = result.data.results.NickName;
            var currentTime = new Date(); //获取当前时间
            var currentHour = currentTime.getHours(); //获取当前小时数（0-23）
            if (currentHour < 12) {
              that.text = '上午'
            } else {
              that.text = '下午'
            }
            var tel = result.data.results.MobileNumber;
            var reg = /^(\d{3})\d{4}(\d{4})$/;
            that.MobileNumber = tel.replace(reg, "$1****$2");
            that.yyjf = result.data.results.Integral;
            that.HeadUrl = result.data.results.HeadUrl;
            that.Number = result.data.results.Number;
            if (that.tokenkey) {
              that.$store.commit("setUserInfo", result.data.results);
            } else {
              that.$store.commit("setUserInfo", {
                Type: 1
              });
            }
          })
          .catch(function(error) {
            // console.log(error);
            that.$message.error(error);
          });
      },
      cutNavMenu(path, index) {
        this.index = index;
        // sessionStorage.setItem("activeIndex", index);
        this.$router.push({
          path: `/personalCentre/${path}`
        });
      },
      // 系统时间
      ServerDateTime() {
        let that = this;
        this.$http
          .get("https://schoolapi.eiceducation.com.cn/api/ServerDateTime")
          .then(function(result) {
            let resultsT = new Date(
              result.data.results.replace("-", "/").replace("-", "/")
            );
            that.DateTime = parseInt(resultsT.getTime() / 1000);
            // // console.log(that.DateTime)
          })
          .catch(function(error) {
            // console.log(error);
            that.$message.error(error);
          });
      },
      leftNav() {
        console.log(this.$route.path)
        var paths = this.$route.path;
        switch (paths) {
          case "/personalCentre/myMission":
            this.index = 1;
            break;
          case "/personalCentre/myLanguage":
            this.index = 2;
            break;
          case "/personalCentre/collectTopic":
            this.index = 3;
            break;
          case "/personalCentre/coupon":
            this.index = 4;
            break;
          case "/personalCentre/notice":
            this.index = 5;
            break;
        }
      },
      toDeviceTest() {
        window.open(
          "https://b96135432.at.baijiayun.com/web/detection/index?webrtc=1&partner_id=undefined"
        );
      }
    }
  };
</script>

<style scoped>
  .wrap_box {
    width: 100%;
    background: #ffffff;
  }

  .wrap_box .top {
    width: 100%;
    height: 160px;
    background: rgba(51, 124, 255, 0.05);
  }

  .wrap_box .top .individuals_box {
    display: flex;
    justify-content: space-between;
    height: 160px;
  }

  .wrap_box .top .individuals_left {
    width: 1000px;
    height: 160px;
    display: flex;
    align-items: center;
  }

  .wrap_box .top .header_shot {
    width: 82px;
    height: 82px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    margin-right: 20px;
  }

  .wrap_box .top .header_shot img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .wrap_box .top .people-name {
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 26px;
    text-align: left;
  }

  .wrap_box .top .people-name span {
    display: block;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 16px;
    padding-top: 10px;
  }

  .wrap_box .top .individuals_right {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 24px;
    padding-top: 50px;
    cursor: pointer;
  }

  .wrap_box .top .individuals_right img {
    display: block;
    width: 24px;
    height: 24px;
  }

  .el-box {
    display: flex;
    padding-top: 50px;
    margin-bottom: 30px;
  }

  .el-box li {
    font-weight: 400;
    font-size: 26px;
    color: #333333;
    line-height: 26px;
    text-align: left;
    margin-right: 50px;
    cursor: pointer;
  }

  .el-box li.active {
    color: #FF0659;
    font-weight: 500;
  }

  .device_test {
    text-align: center;
    font-size: 12px;
    color: #999;
    cursor: pointer;
    line-height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/page/personal-Centre.vue